module.exports = __webpack_public_path__ + "img/zh.31cad061.png";